import keyMirror from 'keymirror';

export default keyMirror({
  POST_ORDER_REQUEST: null,
  POST_ORDER_SUCCESS: null,
  POST_ORDER_FAILURE: null,
});



// WEBPACK FOOTER //
// ./src/api/orders/types.js